import {
  Coffee,
  Croissant,
  Dumbbell,
  Footprints,
  Gamepad2,
  MessagesSquare,
  PartyPopper,
  UtensilsCrossed,
  type LucideIcon,
} from "lucide-react";

/**
 * Host-selectable event icons. The key is what `breakfast_events.icon`
 * persists (allowlist enforced by a DB CHECK constraint — keep the two
 * lists in sync: `supabase/migrations/*_breakfast_event_icons.sql`).
 *
 * A breakfast is only one of the reasons to pick the same office day:
 * coffee, lunch, a ping-pong match, or just a talk all count. The host
 * picks the glyph at creation; every surface (calendar chip, summary
 * cards, planners) renders it through `resolveEventIcon`.
 */
export const EVENT_ICONS: Record<string, { Icon: LucideIcon; label: string }> = {
  croissant: { Icon: Croissant,       label: "Breakfast" },
  coffee:    { Icon: Coffee,          label: "Coffee" },
  lunch:     { Icon: UtensilsCrossed, label: "Lunch" },
  chat:      { Icon: MessagesSquare,  label: "Just talk" },
  games:     { Icon: Gamepad2,        label: "Games" },
  sport:     { Icon: Dumbbell,        label: "Sports" },
  walk:      { Icon: Footprints,      label: "Walk" },
  party:     { Icon: PartyPopper,     label: "Celebration" },
};

export type EventIconKey = keyof typeof EVENT_ICONS;

export const EVENT_ICON_KEYS = Object.keys(EVENT_ICONS) as EventIconKey[];

export const DEFAULT_EVENT_ICON: EventIconKey = "croissant";

/** Unknown / legacy / NULL icon values fall back to the croissant. */
export function resolveEventIcon(key: string | null | undefined): { Icon: LucideIcon; label: string } {
  return EVENT_ICONS[key ?? ""] ?? EVENT_ICONS[DEFAULT_EVENT_ICON];
}
